import styled from 'styled-components';

export const Th = styled.th<{ sortable?: boolean }>`
  padding: 10px 14px !important;
  background-color: #f6f9fc !important;
  color: #8898aa !important;
  font-size: 0.78rem !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-top: 1px solid #e9ecef !important;
  border-bottom: 1px solid #e9ecef !important;
  white-space: nowrap;
  vertical-align: middle;

  /* Modo compacto acionado automaticamente apenas em resoluções menores */
  @media (max-width: 1440px) {
    padding: 8px 6px !important;
    font-size: 0.7rem !important;
    letter-spacing: 0.01em;
  }

  ${props =>
    props.sortable &&
    `
    cursor: pointer;
    user-select: none;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      background-color: #e9ecef !important;
      color: #525f7f !important;
    }
  `}
`;

export const Td = styled.td`
  padding: 10px 14px !important;
  font-size: 0.82rem !important;
  vertical-align: middle !important;
  color: #525f7f;

  /* Modo compacto acionado automaticamente apenas em resoluções menores */
  @media (max-width: 1440px) {
    padding: 8px 6px !important;
    font-size: 0.76rem !important;
  }
`;

export const Tr = styled.tr<{ status?: string }>`
  transition: background-color 0.15s ease;

  ${props =>
    props.status === 'sem_valor_e_custo' &&
    `
    background-color: rgba(245, 54, 92, 0.04);
  `}

  ${props =>
    props.status === 'sem_valor' &&
    `
    background-color: rgba(251, 99, 64, 0.04);
  `}

  ${props =>
    props.status === 'sem_custo' &&
    `
    background-color: rgba(17, 205, 239, 0.04);
  `}

  &:hover {
    background-color: #f4f5f7 !important;
  }
`;

export const KeyBadge = styled.span`
  display: inline-block;
  padding: 2px 7px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 4px;
  background-color: #e9ecef;
  color: #495057;
  font-family: monospace;

  /* Ajuste responsivo de badge em telas menores */
  @media (max-width: 1440px) {
    padding: 1px 5px;
    font-size: 0.69rem;
    border-radius: 3px;
  }
`;

export const DescricaoWrapper = styled.div`
  max-width: 320px;
  min-width: 160px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.25;

  @media (max-width: 1440px) {
    max-width: 210px;
    min-width: 130px;
  }
`;

export const ProdutoWrapper = styled.div`
  max-width: 180px;
  min-width: 100px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.25;

  @media (max-width: 1440px) {
    max-width: 130px;
  }
`;

export const ResponsiveLabel = styled.span`
  .full-label {
    display: inline;
  }
  .short-label {
    display: none;
  }

  @media (max-width: 1440px) {
    .full-label {
      display: none;
    }
    .short-label {
      display: inline;
    }
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  min-width: 250px;
  flex: 1;

  .form-control {
    padding-left: 2.3rem;
    height: 38px;
    font-size: 0.85rem;
  }

  .search-icon {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #adb5bd;
    pointer-events: none;
    z-index: 4;
  }
`;
